// Generado por scripts/cv-pdf/build.js, no editar a mano
export const CV_PDF_VERSION = 'mvtuc2u7';
